import { areDeferredRoutesLoaded, subscribeToDeferredRoutes } from '@client/utils/routing/deferred-route-loader';
import { useSyncExternalStore } from 'react';

/**
 * Whether the deferred route areas (the admin console) have joined the route table.
 *
 * The router instance stays the same when they do, so anything memoised against it alone would
 * keep answering from the smaller table. Route lookups depend on this value instead.
 */
export function useDeferredRoutesLoaded(): boolean {
    return useSyncExternalStore(subscribeToDeferredRoutes, areDeferredRoutesLoaded);
}
